import dialog from "@utils/dialog";
import axios from "axios";

const state = {
  token: null,
  isApply: false,
};

const mutations = {
  LOGIN(state, token) {
    state.token = token;
  },
  LOGOUT(state) {
    state.token = undefined;
  },
  UPDATE_APPLY(state, isApply) {
    state.isApply = isApply;
  },
};

const actions = {
  jwState({ commit }) {
    // 解构state，获取token
    return new Promise((resolve, reject) => {
      // 新增reject
      axios
        .post("/svip-api/jianwei/state")
        .then((res) => {
          commit("UPDATE_APPLY", res.data);
          resolve(res.data); // 成功resolve
        })
        .catch((err) => {
          dialog.error("获取信息失败!");
          reject(err); // 失败reject，让调用方能捕获
          console.error("jwState接口请求失败：", err);
        });
    });
  },
};

export default {
  state,
  mutations,
  actions,
};
